import React from 'react';
import { motion } from 'framer-motion';
import { Section } from '../ui/Section';
import { Palette, Layout, Smartphone, Lock } from 'lucide-react';
const features = [{
  icon: Smartphone,
  title: 'App com sua marca',
  description: 'O ícone e o nome do app são da sua academia.'
}, {
  icon: Palette,
  title: 'Identidade visual',
  description: 'Cores, logos e estilo visual totalmente personalizados.'
}, {
  icon: Layout,
  title: 'Exclusividade',
  description: 'Os alunos sentem que o app foi feito por você.'
}, {
  icon: Lock,
  title: 'Tecnologia robusta',
  description: 'Sistema SaaS escalável por trás da sua marca.'
}];
export function WhiteLabelSection() {
  return <Section background="gray" data-id="element-178">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-179">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} data-id="element-180">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D3748] mb-6" data-id="element-181">
            White-label para a academia
          </h2>
          <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-182">
            Entregue uma experiência premium com a sua marca. O aluno não
            precisa saber que existe um sistema terceirizado por trás.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-183">
            {features.map((feature, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-184">
                <feature.icon className="h-8 w-8 text-[#FF6B35] mb-4" data-id="element-185" />
                <h3 className="font-bold text-[#2D3748] mb-2" data-id="element-186">
                  {feature.title}
                </h3>
                <p className="text-sm text-gray-600" data-id="element-187">{feature.description}</p>
              </div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-188">
          <div className="relative w-[280px] h-[560px] bg-[#2D3748] rounded-[3rem] border-8 border-[#2D3748] shadow-2xl overflow-hidden" data-id="element-189">
            {/* Phone Screen */}
            <div className="absolute top-0 left-0 w-full h-full bg-white flex flex-col" data-id="element-190">
              {/* Status Bar */}
              <div className="h-6 bg-[#2D3748] w-full" data-id="element-191"></div>

              {/* App Header with Custom Brand */}
              <div className="bg-[#FF6B35] p-6 pt-8 text-white" data-id="element-192">
                <div className="w-12 h-12 bg-white/20 rounded-full mb-4" data-id="element-193"></div>
                <div className="h-6 w-32 bg-white/20 rounded mb-2" data-id="element-194"></div>
                <div className="h-4 w-20 bg-white/20 rounded" data-id="element-195"></div>
              </div>

              {/* App Content */}
              <div className="p-4 flex-1 bg-gray-50" data-id="element-196">
                <div className="h-32 bg-white rounded-xl shadow-sm mb-4 p-4" data-id="element-197">
                  <div className="h-4 w-24 bg-gray-100 rounded mb-4" data-id="element-198"></div>
                  <div className="h-16 w-full bg-gray-100 rounded" data-id="element-199"></div>
                </div>
                <div className="grid grid-cols-2 gap-4" data-id="element-200">
                  <div className="h-24 bg-white rounded-xl shadow-sm" data-id="element-201"></div>
                  <div className="h-24 bg-white rounded-xl shadow-sm" data-id="element-202"></div>
                  <div className="h-24 bg-white rounded-xl shadow-sm" data-id="element-203"></div>
                  <div className="h-24 bg-white rounded-xl shadow-sm" data-id="element-204"></div>
                </div>
              </div>
            </div>

            {/* Notch */}
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-32 h-6 bg-[#2D3748] rounded-b-xl" data-id="element-205"></div>
          </div>
        </motion.div>
      </div>
    </Section>;
}